/**
 * 通过应用根节点的 Ant Design 消息上下文展示业务操作成功反馈。
 * 页面应传入与用户动作一致的明确文案，不直接复用接口的通用“操作成功”。
 */
export function notifyOperationSuccess(message: string) {
    const normalizedMessage = message.trim();
    if (!normalizedMessage || typeof window === "undefined") return;

    window.dispatchEvent(
        new CustomEvent("zhihao:global-message", {
            detail: { message: normalizedMessage, type: "success" }
        })
    );
}
